import {Component, Directive, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    standalone: false
}
)

export class ModalComponent{

  @ViewChild('modalBox', { static: true })
  public modalBox:ModalDirective;

  @Input()
  size = 'small';
  @Output() onHide: EventEmitter<any> = new EventEmitter();
  @Input()
  scrollable = false;
  @Input()
  centered = false;
  @Input()
  showHeader = true

  public show():void {
    this.modalBox.show();
  }

  public hide():void {
    this.modalBox.hide();
  }

}
@Directive({
    selector: 'app-modal-header, app-modal-body, app-modal-footer',
    standalone: false
})
export class ModalDirectivesDirective {}
